import { Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Slide, ToastContainer } from 'react-toastify';

import TabBar from '../components/TabBar';
import dashboardIcon from '../assets/icons/dashboard.svg';
import groupUser from '../assets/icons/group.svg';
import logo from '../assets/images/novus.svg';
import outwardArrow from '../assets/icons/outwardArrow.svg';
import 'react-toastify/dist/ReactToastify.css';
import { RootState } from '../store/store';
import {
	autoCloseTimeInMilliseconds,
	errorToastId,
	pendingToastId,
	route,
} from '../constants';
import UnsavedChanges from '../components/UnsavedChanges';
import TimedOutModal from '../components/TimedOut';

const Container = () => {
	const user = useSelector((store: RootState) => store.user);
	const unSavedChanges = useSelector(
		(store: RootState) => store.unSavedChangesReducer,
	);
	const timedOutModal = useSelector(
		(store: RootState) => store.timedOutReducer,
	);

	const tabs = [
		{
			title: 'Dashboard',
			path: `${process.env.PUBLIC_URL}/${route.dashboard}`,
			icon: dashboardIcon,
		},
		{
			title: 'Recruit Information',
			path: `${process.env.PUBLIC_URL}/${route.recruitInformation}`,
			icon: groupUser,
		},
	];

	return (
		<div className="flex flex-col min-h-lvh min-w-[100vw] bg-rcrm-primary-bg relative">
			<UnsavedChanges
				isModalOpen={unSavedChanges.isModalOpen}
				isDirty={unSavedChanges.isDirty || false}
				isNavigationAllowed={unSavedChanges.isNavigationAllowed}
				handleCancel={unSavedChanges?.handleCancel}
				handleConfirm={unSavedChanges?.handleConfirm}
			/>
			<TimedOutModal
				isModalOpen={timedOutModal.isModalOpen}
				subTitleMessage="Due to inactivity your session has expired. Please reload the page."
				titleMessage="Your session has expired"
			/>
			<div className="flex justify-between bg-white sticky top-0 z-40 shadow-sm">
				<div className="flex justify-between align-center px-4 py-2 gap-4 ">
					<img
						className="fill-rcrm-primary-blue w-[200px] h-[60px] object-fill"
						src={logo}
						alt=""
					/>
					<div className="flex gap-2 items-center ">
						<TabBar links={tabs} />
						<div className="flex gap-x-1 items-center text-rcrm-lime underline">
							<p>Recruit Portal</p>
							<img
								className="w-4 h-4 "
								src={outwardArrow}
								alt=""
							/>
						</div>
					</div>
				</div>
				<div className="flex justify-center items-center font-semibold pr-6 ">
					{user.user_name}
				</div>
			</div>
			<div className="min-h-vh min-w-vw p-4">
				<Outlet />
			</div>
			<ToastContainer
				position="top-right"
				autoClose={autoCloseTimeInMilliseconds}
				hideProgressBar={false}
				rtl={false}
				newestOnTop={false}
				theme="light"
				transition={Slide}
			/>
			<ToastContainer containerId={pendingToastId} />
			<ToastContainer containerId={errorToastId} />
		</div>
	);
};

export default Container;
